import React from "react";
import { Portal } from "@app/components";
import {
  Container,
  Backdrop,
  OverLayContainer,
  Title,
  MessageContainer,
} from "./overlay-component";

type Props = {
  children: React.ReactNode;
  title: string;
};

export default function OverLay({ title, children }: Props) {
  return (
    <Portal>
      <Container>
        <Backdrop />
        <OverLayContainer>
          <Title>{title}</Title>
          <MessageContainer>{children}</MessageContainer>
        </OverLayContainer>
      </Container>
    </Portal>
  );
}
